export type AmountUnit = "m³/s" | "m³/min" | "m³/h" | "l/s";
export const allAmountUnits = ["m³/s", "m³/min", "m³/h", "l/s"] as const;

export const mmPerHourToMPerSecond = (mm: number) => {
  return mm / (1000 * 60 * 60);
};
export const mPerSecondToMmPerHour = (m: number) => {
  return m * (1000 * 60 * 60);
};

export const m3PerMinuteToM3PerSecond = (m3: number) => {
  return m3 / 60;
};
export const m3PerHourToM3PerSecond = (m3: number) => {
  return m3 / (60 * 60);
};
export const litrePerSecondToM3PerSecond = (litre: number) => {
  return litre / 1000;
};

export const convertToM3PerSecond = (value: number, unit: AmountUnit) => {
  return unit === "m³/min"
    ? m3PerMinuteToM3PerSecond(value)
    : unit === "m³/h"
    ? m3PerHourToM3PerSecond(value)
    : unit === "l/s"
    ? litrePerSecondToM3PerSecond(value)
    : value; //  unit === "m³/s"
};
